var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion__group mt-5" },
    [
      _vm.books.length
        ? _c(
            "div",
            {
              staticClass: "text-right mb-3 cursor-pointer",
              attrs: { v: "" },
              on: {
                click: function($event) {
                  return _vm.toggleOpen()
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.accordionToggleText) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("Loader") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.books, function(book, index) {
        return _c("Info", {
          key: book.uid,
          staticClass: "primary-text zebra-background",
          attrs: { book: book, open: _vm.openIndex === index || _vm.openAll },
          on: {
            openChange: function($event) {
              $event ? (_vm.openIndex = index) : (_vm.openIndex = null)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }